'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024$0024anon$002487 from "./presto.types$-Role-Name$$anon$87.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleName$() {
  this.c8y = null;
  this.c8z = false;
  this.c8C = null;
  this.c8D = false;
  this.c8A = null;
  this.c8B = false;
}
export { $c_Lpresto_types$RoleName$ as $c_Lpresto_types$RoleName$ };
$p = $c_Lpresto_types$RoleName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleName$;
/** @constructor */
function $h_Lpresto_types$RoleName$() {
}
export { $h_Lpresto_types$RoleName$ as $h_Lpresto_types$RoleName$ };
$h_Lpresto_types$RoleName$.prototype = $p;
$p.nO = (function() {
  if ((!this.c8z)) {
    this.c8y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c8z = true;
  }
  return this.c8y;
});
$p.cIf = (function() {
  if ((!this.c8D)) {
    this.c8C = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8D = true;
  }
  return this.c8C;
});
$p.crJ = (function() {
  if ((!this.c8B)) {
    this.c8A = new $j_presto$002etypes$0024$002dRole$002dName$0024$0024anon$002487.$c_Lpresto_types$RoleName$$anon$87(this);
    this.c8B = true;
  }
  return this.c8A;
});
var $d_Lpresto_types$RoleName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleName$, "presto.types$RoleName$", ({
  a1r: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleName$ as $d_Lpresto_types$RoleName$ };
var $n_Lpresto_types$RoleName$;
function $m_Lpresto_types$RoleName$() {
  if ((!$n_Lpresto_types$RoleName$)) {
    $n_Lpresto_types$RoleName$ = new $c_Lpresto_types$RoleName$();
  }
  return $n_Lpresto_types$RoleName$;
}
export { $m_Lpresto_types$RoleName$ as $m_Lpresto_types$RoleName$ };
//# sourceMappingURL=presto.types$-Role-Name$.js.map
